
export default class{

    constructor(options) {
        this.defaults = {
        	$el: false,
        	window_size: {
        		'default'		: [680, 420 ],
        		'newsletter' 	: [1280,850]
        	}
        }
        this.options  		= {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 'open-popup';
		this.$el 			= this.options.$el;
		
		this.url 			= this.$el.attr( 'href' );


		this.mode 	= 'default';
		if ( this.$el.hasClass( 'newsletter' ) ){
			this.mode = 'newsletter';
		}

		this.addEvents(true);
    }


    addEvents(b){
    	if ( b ){
    		this.$el.on( 'click', (e)=>{this.onClick(e)} );
    	}
    	else{
    		this.$el.off( 'click', (e)=>{this.onClick(e)} );
    	}
    }

    onClick(e){
    	e.preventDefault();
    	this.openWindow( this.url );
    }

	openWindow(url) {
	    let sizes = this.options.window_size[ this.mode ],
	    		w 	= screen.availWidth,
	    		h 	= screen.availHeight,
				left, top, ww, hh, params;

		ww 		= Math.min( w, sizes[0]);
		hh 		= Math.min( h, sizes[1]);
	    left 	= (w - ww)/2;
	    top 	= (h - hh)/2;


	    params = "menubar=no,toolbar=no,status=no,width=" + ww + ",height=" + hh + ",top=" + top + ",left=" + left;
	    window.open(url,"NewWindow",params);
	}

    destroy(){
    	this.addEvents( false );
    }

}